import {
  types as t,
  getParent
} from '@invisr/mobx-state-tree'
import crudActions from './crud-actions'

const Position = t
  .model({
    x: t.maybeNull(t.number),
    y: t.maybeNull(t.number),
    h: t.maybeNull(t.number),
    w: t.maybeNull(t.number)
  })
  .views(self => ({
    get parent () {
      return getParent(self)
    },
    get i () {
      const { id } = self as any
      return id + ':' // + [x, y, w, h].join('-')
    },
    get id () {
      return getParent<any>(self)?.id ?? null
    },
    get grid () {
      const { x, y, w, h, i } = self as any
      const hh = h
      //      let parent = getParent(self)
      //      if (hh <= parent.maxY) hh = parent.maxY

      return { x, y, w, h: hh, i }
    },
    get maxExpandY () {
      const parentComponent = (self as any).parent.parent
      let minMaxH = Infinity
      if (parentComponent?.position) {
        for (const c of parentComponent.components) {
          const p = c.position
          if (c === (self as any).parent || p.y < (self.y + self.h)) continue
          if (lineContains(self.x, self.x + self.w, p.x, p.x + p.w)) {
            const maxH = p.y - 1
            if (maxH < minMaxH) minMaxH = maxH
          }
        }
      }
      return minMaxH
    },
    get maxExpandH () {
      return (self as any).maxExpandY - self.y + 1
    }
  }), { 
    maxExpandY: { memoize: true },
    maxExpandH: { memoize: true }
  })
  .actions(self => ({
    resize (ratio, axis = 'x') {
      if (axis === 'x') self.w = Math.floor(48 * ratio)
      else self.h = Math.floor(ratio)
    },
    align (a) {
      const maxY = (self.parent as any)?.parent?.maxY
      switch (a) {
        case 'left':
          self.x = 0
          break
        case 'center':
          self.x = 24 - Math.floor(self.w / 2)
          break
        case 'right':
          self.x = 48 - self.w
          break
        case 'top':
          self.y = 0
          break
        case 'bottom':
          if (maxY) self.y = maxY
          break
        case 'horizontal-center':
          if (maxY) self.y = Math.floor(maxY / 2)
          break
      }
    }
  }))
  .actions(crudActions)

export default Position

function lineContains (x1: number, x2: number, x3: number, x4: number) {
  if (x3 >= x1 && x3 < x2) return true
  if (x4 > x1 && x4 <= x2) return true
  if (x1 >= x3 && x1 < x4) return true
  if (x2 > x3 && x2 <= x4) return true

  return false
}
